import moment from 'moment';

const week = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const year = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
const month = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
];

function formatDate(date) {
  var dd = date.getDate();
  var mm = date.getMonth() + 1;
  // var yyyy = date.getFullYear()
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  date = dd + '/' + mm;
  return date;
}

function LastxDays(num) {
  var result = [];
  for (var i = 0; i < num; i++) {
    var today = new Date();
    let d = new Date(today); // Creates a new Date object as a copy of 'today'
    d.setDate(today.getDate() - 1);
    // console.log(d);
    d.setDate(d.getDate() - i);
    result.push(formatDate(d));
  }
  return result.reverse();
}

function LastDays(startDate, endDate) {
  var result = [];
  let diff = moment(endDate).diff(moment(startDate), 'days');
  console.log(diff);
  for (var i = 0; i <= diff; i++) {
    var d = new Date(moment(startDate).add(i, 'days').format('YYYY-MM-DD'));
    result.push(
      moment(startDate).add(i, 'days').format('DD') +
        '/' +
        moment(startDate).add(i, 'days').format('MM')
    );
  }
  return result;
}
const last7Days = LastxDays(7);
const last30Days = LastxDays(30);
const last60Days = LastxDays(60);
const last90Days = LastxDays(90);

export {
  week,
  month,
  last7Days,
  last30Days,
  last60Days,
  last90Days,
  year,
  LastDays,
};
